const Language = {
	jp: {
		label: {
			view_profile: 'プロファイルを見る',
			list: 'ステーション',
			enter_mobile_number: '携帯電話番号を入力してください 📱',
			enter_your_name: 'こんにちわ、あなたの名前は? 👋',
			enter_your_email: 'あなたのメールアドレスを入力してください 📧',
			email_message: '請求書発行に必要なメールアドレス',
			confirm_country_code_enter_mobile_number: '国番号を確認し、携帯電話番号を入力してください',
			mobile_verification: 'モバイル認証',
			confirm_mobile_verification_code: "確認のため、携帯電話番号にお送りした4桁のコードを入力してください.",
			connectors: 'コネクター:',
			connector_type: 'コネクターのタイプ',
			units_consumed: '消費ユニット',
			amount_spent: '支出量',
			co2_saved: 'CO2節約',
			name: '名前',
			mobile: 'モバイル',
			email: 'メール',
			vehicle_number: "自動車番号",
			battery_started_at: 'バッテリー始動',
			remperreq: '覚書きと必要事項',
			time: '時間',
			amt: 'ユニット',
			elapsed_time: '経過時間',
			remaining_time: '残り時間',
			remaining_amount: '残りユニット',
			remaining_unit: '残りユニット',
			charging_summary: '充電の概要',
			charger_id: '充電器ID',
			start_time: '開始時間',
			end_time: '終了時間',
			charge_start_percent: '充電開始 %',
			charge_end_percent: '充電終了 %',
			gun: 'ガン',
			pricing: '価格',
			end_reason: '終了理由',
			charging_status: '充電の状態',
			connected: '接続',
			charging: '充電中',
			battery_information: '充電器の情報',
			consumed: '消費済み',
			battery: 'バッテリー',
			amount: 'ユニット',
			total: '合計',
			free: '無料',
			private: 'プライベート',
			public: '公共',
			capacity: '容量',
			price: '料金',
			unit: 'ユニット',
			set_time: 'セット時間',
			set_unit: 'セットユニット',
			set_price: 'セット料金',
			wallet_balance: 'ウォレット残高',
			wallet_balance_kwh: 'kWh 残高',
			available_balance: '利用可能 残高',
			estimate: '見積もり料金',
			estimate_kwh: '見積もり kWh',
			enter_valid_phone_number: '有効な電話番号を入力してください',
			enter_valid_otp: '有効なワンタイムパスワードを入力してください',
			phone_number: '電話番号',
			country: '国',
			enter_otp: 'ワンタイムパスワードを入力してください',
			firstname: '名',
			email_address: 'メールアドレス',
			password: 'パスワード',
			otp: 'ワンタイムパスワード',
			keep_me_sign_in: 'サインインを維持する',
			india: 'インド',
			japan: '日本',
			thailand: 'タイ',
			settings: "設定",
			change_language: "言語の変更",
			select_language: "言語の選択",
			full_charge: "フル充電",
			indonesia: "インドネシア",
			charger_status: "充電器の状態",
			faulted: "不具合",
			finishing: "完了",
			charging_fee: '充電料金',
			booking_overtime: '予約の超過時間',
			overtime_fee: '超過料金',
			your_booking_overtime: 'あなたの予約の超過時間',
			invoice_address: '住所',
			otp_login: "ここをクリック：ワンタイムパスワードログインの場合　",
			password_login: "ここをクリック：パスワードログインの場合",
			initial_balance: "初期残高",
			final_balance: "最終残高",
			order_placed: "ご注文は確認され、まもなく配送されます",
			order_id: "オーダーID",
			order_date: "オーダー日",
			estimate_delivery: "お届け予定日",
			delivery_status: "配送状況",
			tracking_id: "トラッキングID",
			rfid: "RFID",
			terra_charge: " Terra Charge",
			grow_together: "Let's grow together",
			order_rfid: "RFIDのオーダー",
			claim_rfid: "無料RFIDを請求",
			coupon: "クーポン",
			coupon_discount: "クーポン割引",
			add_a_review: "レビューを追加",
			payment: "支払い",
			billing: "請求書",
			vehicle: "車両",
			disconnected: "接続切断",
			location_type: "場所のタイプ",
			amount_deducted: "差し引かれた金額",
			amount_refunded: "返金額",
			address_details: "住所の詳細",
			enter_billing_address: "請求先住所を入力してください"

		},
		placeholder: {
			mobile_number: '電話番号',
			enter_full_name: 'フルネーム入力',
			enter_email: 'メールアドレス入力',
			country_code: '国コード',
			otp: 'ワンタイムパスワード',
			resend_otp: ' {seconds} 秒後に再送信',
			phone_number: '10桁の電話番号入力',
			enter_password: 'パスワード入力',
			enter_otp: 'ワンタイムパスワード入力',
			firstname: '太郎',
			email_address: 'demo@company.com',
			faq_whatsapp: "質問を入力"
		},
		heading: {
			amount_in_wallet: 'あなたのウォレット残高:',
			balance: '残高',
			balance_kwh: 'kWh 残高',
			last_transaction: '最後の取引',
			terms_of_service: '利用規約',
			privacy_policy: 'プライバシーポリシー',
			please_type_the: 'を入力してください',
			add_vehicle: '車両追加',
			my_usage: '私の使用量',
			charging_sessions: '充電セクション',
			upcoming: '今後の予定',
			past: '過去',
			cancelled: 'キャンセル',
			facing_issue_charging: '充電中に何か問題がありましたか？',
			terra_wallet: 'Terra ウォレット',
			estmate_approx: '見積もり（概算）',
			already_have_account: '既にアカウントをお持ちですか?',
			signup: 'アカウント新規登録',
			dont_have_account: 'アカウントをお持ちではないですか?',
			login: 'ログイン',
			forgot_password: 'パスワードを忘れた',
			back_to_login: 'ログインに戻る',
			home: 'ホーム',
			signup_with: 'アカウント登録',
			login_with: 'ログイン',
			dashboard: 'ダッシュボード',
			profile: 'プロフィール',
			wallet: 'ウォレット',
			my_vehicles: '私の車両',
			charging_history: '充電履歴',
			contact_us: 'お問い合わせ',
			logout: 'ログアウト',
			map: 'マップ',
			history: '履歴',
			terra_motors_country: 'Terra Motors.',
			unpaid_fees: '未払い料金',
			available_coupons: '利用可能クーポン',
			rfid_registrations: 'RFID登録',
			rate_session: "セクションを評価しますか？",
			profile_url_desc: '氏名、電話番号、住所の追加と編集する',
			wallet_url_desc: "ウォレット残高の追加、簡単な取引、取引詳細の表示'する",
			my_vehicles_url_desc: '私の車両',
			charging_history_url_desc: '充電履歴の詳細を表示する',
			contact_us_url_desc: '問題で行き詰まりましたか？ 私たちがお答えします',
			logout_url_desc: 'プロフィールからログアウトする',
			map_url_desc: 'マップ',
			history_url_desc: '履歴',
			privacy_policy_us_url_desc: "データの収集、使用、保護について読む",
			rfid_registrations_url_desc: 'RFIDカードを登録・受け取り、スキャナーをタップして充電する',
			favourite_charging_station: 'お気に入りの充電ステーション',
			favourite_charging_station_url_desc: "お気に入りに登録した充電ステーションを見る",
			customer_support: "カスタマーサポート",
			customer_support_url_desc: "お問い合わせにお答えします",
			faq: "よくある質問",
			notification: 'お知らせ',
			notification_url_desc: 'あなたの車両、ウォレットや請求書、過去の充電詳細を表示する',
			ratings: '評価',
			last_session: '最終セッション',
			total_connectors: 'ガン',
			rating: '評価',
			available_connectors: '使用可能なガン',
			shop: 'ショップ',
			order_history: 'オーダー履歴',
			order_history_url_desc: '購入した充電器の注文履歴を見る'
		},
		list: {
			charging_statuses: {
				charging: '充電',
				abandoned: '中断',
				available: '利用可能',
				completed: '完了',
				initiated: '開始',
				preparing: '準備中'
			}
		},
		button: {
			continue: 'ログイン',
			save: 'セーブ',
			topup: '補充',
			add_money: '課金',
			map_view: 'マップを見る',
			type_device_id: 'デバイスIDを入力',
			activate: '有効化',
			resend_otp: 'ワンタイムパスワード再送',
			password: 'パスワード',
			cancel: 'キャンセル',
			update: '更新',
			logout: 'ログアウト',
			cancel_goback: '戻る（キャンセル）',
			confirm_delete: '削除の確認',
			continue_on_app: 'ウェブアプリを続行',
			click_to_call: 'お電話でのお問い合わせはこちら',
			or_dial: 'または電話',
			stop_charging: '充電停止',
			wallet_link: 'ウォレット',
			next_disabled: '時間または価格が選択されると、ボタンが有効になります',
			next: '次',
			start_charging: '充電開始',
			verify_otp: 'ワンタイムパスワード認証',
			send_otp: 'ワンタイムパスワード発信',
			send_password: 'パスワード発信',
			create_account: 'アカウント作成',
			login: 'ログイン',
			credit: 'クレジット/デビット',
			qr: 'QR',
			select: '選択',
			confirm_country_change: '国の変更実施',
			enter_new_address: '新しい住所の入力',
			add_billing_address: '請求先住所を追加',
			download_invoice: 'ダウンロード',
			generate_invoice: 'ダウンロード',
			scan_to_checkout: 'スキャンして清算',
			make_payment: '支払い',
			purchase_kwh: "kWh 購入",
			apply_now: "今すぐ申し込み",
			back_to_home: "ホームに戻る",
			track_shipment: "荷物の追跡",
			place_order: "発注",
			already_requested: "既にリクエスト済み",
			apply_coupon: "クーポン適用",
			submit: "提出",
			apply_all: "全て適用",
			clear_all: "全てクリア",
			share: "共有",
			change: "変更"
		},
		generic: {
			or: 'もしくは',
			and: 'と',
			continue_with_google: 'Googleで続ける',
			agree_terms_conditions: '続行することに、あなたは私達の以下事項に同意します',
			terms_and_conditions: 'ご利用条件',
			privacy_policy: 'プライバシーポリシー',
			currency_char: '円',
			device_id: 'デバイス ID',
			month: '月',
			week: '週',
			months: {
				jan: '１月',
				feb: '２月',
				mar: '３月',
				apr: '４月',
				may: '５月',
				jun: '６月',
				jul: '７月',
				aug: '８月',
				sep: '９月',
				oct: '１０月',
				nov: '１１月',
				dec: '１２月',
			},
			days: {
				mon: '月',
				tue: '火',
				wed: '水',
				thu: '木',
				fri: '金',
				sat: '土',
				sun: '日'
			},
			open24in7: '年中無休',
			download_app: 'Terra Chargeアプリをダウンロード',
			phone_no: '03-6824-0797',
			available: '利用可能',
			dateandtime: '日時',
			amount: '量',
			kwh: 'kWh',
			kw: 'kW',
			hour: '時間',
			minute: '分',
			hours: '時間',
			mins: '分',
			seconds: '秒',
			update_available: "アプリのアップデートが可能",
			faq_more_help: "もっとサポートが必要",
			faq_was_this_helpful: "このコンテンツは役に立ちましたか？",
			contact_whatsapp: "ご質問とご連絡は",
			session_since: "1回目以降の取引",
			total_session: "1回目からの通算取引",
			type: "タイプ",
			line_channel: "LINE",
			whatsapp_channel: "WhatsApp",
			transaction_id: "トランザクション ID"
		},
		message: {
			no_internet_wrapper: 'インターネットに接続できません、後でもう一度お試しください',
			not_valid_qr_code: '有効なコードではないです',
			you_dont_have_vehicles: '保存した車両がありません',
			you_dont_have_charging: '充電した履歴がありません',
			loading: '更新中...',
			no_charging_records: '充電履歴が見つかりません',
			nothing_found_in_upcoming: '今後の使用がありません',
			nothing_found_in_past: '過去の使用がありません',
			nothing_found_in_cancelled: 'キャンセルされたものがありません',
			are_you_sure_delete_account: '本当にアカウントを削除しますか？',
			delete_acccount_warning: 'アカウントを削除することで、アカウントへのアクセスができなくなり、すべてのデータが7日以内に削除される予定であることを確認する必要があります',
			error_boundary: 'エラーバウンダリーでエラーが検出されました',
			something_went_wrong: '間違いがあります',
			stopping: '停止中.....',
			use_this_slider_set_session: 'このスライダーを使用して、充電セッションを"価格"または"時間"で設定します。',
			use_this_slider_time_amount: 'このスライダーを使用して、充電セッションを継続する"時間"または"量"を選択します。 選択した"時間"または"金額"に達すると、充電は自動的に停止します。',
			charger_not_found: '充電器が見つからない',
			loging_out: 'ログアウト.....',
			otp_cannot_empty: 'ワンタイムパスワードが未入力です',
			resend_otp_in: '再送信',
			registration_successful: '登録成功です  電話番号を確認してください',
			verify_inputs: '入力を確認してください',
			by_siging_up_agree: '登録することで、あなたは私達に同意します',
			redirecting: 'リダイレクト中...',
			all_right_reserve: '無断複写・転載を禁じます',
			confirm_change_country: '警告： 国を変更しようとしています！',
			change_country_warning: '国を変更するとワンタイムパスワードが届かなかったり、ログインできない場合があります',
			penalty_is_running: 'ペナルティは実行中',
			please_settle_the_fines: '罰金を清算してから使用してください',
			outstanding_amount: '時間外駐車違反の罰金の未払いがある',
			charger_is_starting_up: '充電器が始動',
			charge_info_group_1_1: 'お願い',
			charge_info_group_1_2: 'ロック',
			charge_info_group_1_3: 'あなたの車両と',
			charge_info_group_1_4: '接続',
			charge_info_group_1_5: '充電器ケーブル',
			please_dont_close_the_app: 'アプリを閉じないでください',
			get_ready: '準備はいいでしょうか',
			charge_info_group_2_1: 'お車のピックアップをお忘れなく',
			charge_info_group_2_2: '追加料金を避けるため、期限内に',
			please_pay: '充電セッションを完了する前に、お支払いをお願いします',
			session_is_overtime: 'セッションは時間超過しています !',
			additional_overtime: '追加充電の超過時間',
			balance_not_enough: '残高が不足しています、課金してください.',
			no_charger_found: "充電器が見つかりません",
			unable_to_stop_charging: "1分以内では充電を止めることができません、もう一度お試しください",
			select_address_to_download_invoice: "請求書をダウンロードする住所を選択してください。",
			select_address_to_request_rfid: "RFIDを希望する住所を選択してください。",
			no_coupons_found: "クーポンが見つかりません",
			add_to_wallet: "ウォレットに*/money/*を追加する",
			applied: "適用",
			coupon_apply_after_session_note: "注意： - クーポンはチャージセッション終了時にのみ適用されます",
			feedback_is_important: "お客様の声は私たちにとって非常に重要です",
			no_notification: "通知記録がありません",
			no_ameneties_available: 'アメニティがありません',
			no_image_available: '画像なし',
			access_denied: "このステーションへのアクセスが制限されています",
			faq_not_enabled: " あなたの国ではFAQ機能が有効になっていません",
			waitingForConnector: "コネクタの接続を待っています",
			ensureConnectorPlugged: "スムーズな充電のために、コネクタが正しく接続されていることをご確認ください。",
			connectorNotPluggedProperly: "充電を開始するには、コネクタが正しく接続されていません。",
			download_invoice_before_share: "共有する前に請求書をダウンロードしてください。",
			already_generated_invoice: "請求先住所はすでに保存されています。請求書を直接ダウンロードできます。",
		}
	}
};

export default Language;